import { useMemo } from 'react';
import { useThemeStore } from '../store/themeStore';
import { readToken } from '../lib/theme';

export interface ChartTheme {
  axis: string;
  grid: string;
  tooltipBg: string;
  tooltipBorder: string;
  tooltipLabel: string;
  accent: string;
}

/**
 * Chart colours resolved to concrete values.
 *
 * Recharts applies colours as SVG presentation attributes, which do not
 * resolve `var(--x)`, so the tokens have to be read off the document. Keyed on
 * the current appearance so the values are recomputed when the theme changes.
 */
export function useChartTheme(): ChartTheme {
  const appearance = useThemeStore(s => s.appearance);

  return useMemo(
    () => ({
      axis: readToken('--color-chart-axis'),
      grid: readToken('--color-chart-grid'),
      tooltipBg: readToken('--color-chart-tooltip-bg'),
      tooltipBorder: readToken('--color-chart-tooltip-border'),
      tooltipLabel: readToken('--color-chart-tooltip-label'),
      accent: readToken('--color-accent'),
    }),
    [appearance]
  );
}
